import { PlateElement } from 'platejs/react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function BreakElement(props) {
  return _jsx(PlateElement, {
    as: "span",
    contentEditable: false,
    ...props,
    children: _jsx("br", {})
  });
}
export default BreakElement;